import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { GithubIcon } from './GithubIcon';
import { SignInLayout, SignInProviders } from './SignInLayout';

const signInProviders: SignInProviders = [
  {
    id: 'github-auth-provider',
    title: 'GitHub',
    message: 'Sign in using GitHub',
    apiRef: githubAuthApiRef,
    icon: <GithubIcon />,
  },
  // Guest sign-in is only offered locally; the backend rejects it elsewhere.
  ...(process.env.NODE_ENV === 'development' ? ['guest' as const] : []),
];

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      <SignInLayout {...props} providers={signInProviders} />,
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
